var exports = {
  "p_": "x8b4e8595--5f4bb7--list",
  "Vg": "x8b4e8595--5f4bb7--grid",
  "N_": "x8b4e8595--5f4bb7--grid-without-skeletons",
  "ld": "x8b4e8595--5f4bb7--items",
  "BA": "x8b4e8595--5f4bb7--shimmer-boundary",
  "nM": "x8b4e8595--5f4bb7--row",
};

module.exports = exports;
